/* eslint-disable @typescript-eslint/no-var-requires */

import { colors } from '@lmc/common/constants'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import React, { type ReactElement, useRef } from 'react'

// @ts-ignore
// removed
// import HighchartsMore from 'highcharts-more'

// HighchartsMore(ReactHighcharts.Highcharts)

interface PieChartProps {
  data: Record<string, number>
}

export function PieChart({ data }: PieChartProps): ReactElement {
  const chartComponentRef = useRef(null)

  const config = {
    title: {
      text: '',
      align: 'center'
    },
    chart: {
      height: 250
    },
    tooltip: {
      valueDecimals: 0
    },
    plotOptions: {
      series: {
        borderWidth: 0,
        colorByPoint: true,
        type: 'pie',
        size: '100%',
        innerSize: '70%'
      }
    },
    credits: {
      enabled: false
    },
    colors: [
      colors.darkpurple,
      colors.red,
      colors.primary,
      colors.orange,
      colors.successgreen
    ],
    series: [
      {
        type: 'pie',
        name: 'Funding',
        data: Object.keys(data).map((key) => [key, data[key]])
      }
    ]
  }

  return (
    <HighchartsReact
      highcharts={Highcharts}
      ref={chartComponentRef}
      options={config}
    />
  )
}

export default PieChart
